export var ProjectType;
(function (ProjectType) {
    ProjectType["Prototype"] = "PROTOTYPE";
    ProjectType["UserTest"] = "USERTEST";
    ProjectType["Whiteboard"] = "WHITEBOARD";
})(ProjectType || (ProjectType = {}));
